import React, { useState, useEffect } from "react";
import {
  Modal,
  Input,
  Button,
  Space,
  Typography,
  message as antMessage,
  Tag,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import Table from "../../../../../core/common/dataTable/index"
import { useDispatch } from "react-redux";
import { all_routes } from "../../../../router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { deleteWabaTemplate, fetchWabaTemplates } from "../../../../../core/data/redux/slices/WabaTemplateSlice";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { useDebounce } from "../../../../../core/hooks/useDebounce";


const { Text } = Typography;

const WabaTemplates = () => {
  const route = all_routes;
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [deleteTemplateModal, setDeleteTemplateModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templates, setTemplates] = useState([])


  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearch = useDebounce(searchValue, 500);

  const { wabaTemplates, loading, pagination } = useSelector((state) => state.wabaTemplate)

  console.log(wabaTemplates, "wabaTemplates");

  const userProfile = useSelector((state) => state.profile);
const role = userProfile?.role
  const isWhatsappConnected =
    userProfile?.accounts?.whatsapp?.isConnected;
  useEffect(() => {

    const payload = {
      page: currentPage,
      limit: pageLimit,
      search: debouncedSearch,
    }


    dispatch(fetchWabaTemplates(payload))
  }, [currentPage, pageLimit, debouncedSearch])
  useEffect(() => {
    setTemplates(wabaTemplates)
  }, [wabaTemplates])
  useEffect(() => {
    setCurrentPage(1);
  }, [searchValue]);

  const handleDeleteTemplate = async () => {
    if (!selectedTemplate) return;

    setIsSubmitting(true);
    try {

      dispatch(deleteWabaTemplate(selectedTemplate.name))

      setDeleteTemplateModal(false);
      setSelectedTemplate(null);

    } catch (error) {
      console.error("Error deleting agent:", error);
      antMessage.error(
        error.response?.data?.message ||
        "Failed to delete template. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      width: 200,
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text, record) => {
        console.log(record, "record");

        return (
          <Link
            className="customer-name"
            to={route.wabaAddTemplate}
            state={{ record }}
            style={{
              color: "#2c5cc5",
              fontWeight: 700,
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={text}
          >
            {text || "N/A"}
          </Link>
        )

      },
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (text) => {

        return (
          <div>{text}</div>
        )
      }
    },
    {
      title: "Preview",
      // dataIndex: "preview",
      dataIndex: "components",
      ellipsis: true,
      render: (components) => {
        // Find the component with type 'BODY'
        const bodyComponent = components?.find((c) => c.type === "BODY");
        const text = bodyComponent?.text || "N/A";

        return (
          <Typography.Text ellipsis={{ tooltip: text }}>
            {text}
          </Typography.Text>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        switch (status) {
          case "APPROVED":
            return <Tag color="success">Approved</Tag>;
          case "PENDING":
            return <Tag color="warning">Pending</Tag>;
          case "REJECTED":
            return <Tag color="error">Rejected</Tag>;
          default:
            return <Tag>Unknown</Tag>;
        }
      },
    },
    {
      title: "Last Updated",
      dataIndex: "updatedAt",
      sorter: (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt),
      render: (text) => dayjs(text).format("DD MMM YYYY, hh:mm A")
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Link
            // type="link"
            // icon={}
            state={{ record }}
            to={role === "user" ? route.agentWabaAddTemplate : role === "superadmin" ? route.adminWhatsappAddTemplate : route.wabaAddTemplate}
          >
            <i className="ti ti-edit" />
          </Link>
          {role=="companyAdmin" &&<Button
            type="link"
            danger
            icon={<i className="ti ti-trash" />}
            onClick={() => {
              setSelectedTemplate(record);
              setDeleteTemplateModal(true);
            }}
          >

          </Button>}
        </Space>
      ),
    },
  ];


  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">


              {isWhatsappConnected === false ? (

                <div
                  style={{
                    height: "70vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <h3>WhatsApp is not connected</h3>
                  <p style={{ color: "#888", marginBottom: 20 }}>
                    Please configure WhatsApp to start chatting.
                  </p>

                 <button
              className="btn btn-primary"
              onClick={() => {
                if (userProfile?.role === "companyAdmin") {
                  navigate(route.wabaSetting);
                } else if (userProfile?.role === "superadmin") {
                  navigate(route.adminWhatsappSetting);
                }
              }}
              disabled={userProfile?.role !== "companyAdmin" && userProfile?.role !== "superadmin"}
            >
              {userProfile?.role === "companyAdmin" || userProfile?.role === "superadmin"
                ? "Go to WhatsApp Settings"
                : "Contact your Company Admin"}
            </button>
                </div>

              ) :

                <div className="card">
                  <div className="card-header">
                    <div className="row align-items-center">
                      <div className="col-sm-12">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="page-header mb-0">
                            <div className="row align-items-center">
                              <h4 className="page-title mb-0">
                                Templates
                              </h4>
                            </div>
                          </div>
                          <div>

                            <Input
                              placeholder="Search templates..."
                              value={searchValue}
                              onChange={(e) => {
                                setCurrentPage(1);
                                setSearchValue(e.target.value);
                              }}
                              style={{ width: 250, marginRight: 10 }}
                            />
                            <Button
                              icon={<ReloadOutlined />}
                              onClick={() => dispatch(fetchWabaTemplates({ page: currentPage, limit: pageLimit, search: debouncedSearch }))}
                              loading={loading}
                              style={{ marginRight: 10 }}
                            >
                              Refresh
                            </Button>
                            <Button
                              type="primary"
                              onClick={() => navigate(role === "user" ? route.agentWabaAddTemplate : role === "superadmin" ? route.adminWhatsappAddTemplate : route.wabaAddTemplate)}
                            >
                              <i className="ti ti-plus me-2" />
                              Add Template
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="table-responsive">
                      <Table
                        columns={columns}
                        dataSource={templates}
                        loading={loading}
                        rowKey="_id"
                        pagination={{
                          current: currentPage,
                          pageSize: pageLimit,
                          total: pagination?.total,
                          showSizeChanger: true,
                          showQuickJumper: false,
                          showTotal: (total, range) =>
                            `Showing ${range[0]}-${range[1]} of ${total} campaigns`,
                        }}
                        onPaginationChange={(page, pageSize) => {
                          setCurrentPage(page);
                          setPageLimit(pageSize);
                        }}
                        showRowSelection={false}
                      />

                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      {/* Delete Agent Modal */}
      <Modal
        title="Delete Template"
        centered
        open={deleteTemplateModal}
        onCancel={() => {
          setDeleteTemplateModal(false);
        }}
        footer={null}
        width={500}
      >
        <div style={{ padding: "20px 0" }}>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <div>
              <Text style={{ fontSize: "16px" }}>
                Are you sure you want to delete template?
              </Text>
              <br />
              <br />
              <Text type="danger" style={{ fontSize: "14px" }}>
                This action cannot be undone. The template will
                also be deleted.
              </Text>
            </div>

            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <Button
                size="large"
                onClick={() => {
                  setDeleteTemplateModal(false);
                  setSelectedTemplate(null);
                }}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                size="large"
                onClick={handleDeleteTemplate}
                loading={isSubmitting}
              >
                Delete Template
              </Button>
            </Space>
          </Space>
        </div>
      </Modal>
    </>
  );
};

export default WabaTemplates;